import angular from 'angular'
import moment from 'moment-timezone'

angular.module('pub.games.edit', []).controller('GameEditCtrl', GameEditCtrl)

/** @ngInject */
function GameEditCtrl($stateParams, $scope, $state, GameService, UploadService) {
  const vm = this
  vm.channelId = $stateParams.channelId
  vm.gameId = $stateParams.gameId || null // ← detect edit vs create
  vm.model = { itms: [] }

  vm.isOpen1 = false
  vm.isOpen2 = false
  vm.isOpen3 = false
  vm.isOpen4 = false

  vm.loadB = false
  vm.loadBMob = false
  vm.loadT = false
  vm.loadPB = false
  vm.loadPBMob = false
  vm.loadPrizeThumb = false

  vm.isUpload = false

  vm.statusList = [
    { id: 0, name: 'Draft' },
    { id: 1, name: 'Published' },
    { id: 4, name: 'Archived' },
  ]

  vm.itemsOrder = [
    { id: 1, name: '1st' },
    { id: 2, name: '2nd' },
    { id: 3, name: '3rd' },
    { id: 4, name: '4th' },
  ]

  // Dynamic UI text
  vm.isEdit = !!vm.gameId
  vm.pageTitle = vm.isEdit ? 'Edit Game' : 'Create New Game'
  vm.buttonText = vm.isEdit ? 'Save Changes' : 'Create Game'

  // Calendar
  vm.openCalendar = function (e, type) {
    e.preventDefault()
    e.stopPropagation()
    switch (type) {
      case 1:
        vm.isOpen1 = true
        vm.isOpen2 = false
        vm.isOpen3 = false
        vm.isOpen4 = false
        break
      case 2:
        vm.isOpen1 = false
        vm.isOpen2 = true
        vm.isOpen3 = false
        vm.isOpen4 = false
        break
      case 3:
        vm.isOpen1 = false
        vm.isOpen2 = false
        vm.isOpen3 = true
        vm.isOpen4 = false
        break
      case 4:
        vm.isOpen1 = false
        vm.isOpen2 = false
        vm.isOpen3 = false
        vm.isOpen4 = true
        break
    }
  }

  // Load existing game (edit mode)
  if (vm.isEdit) {
    GameService.getById(vm.channelId, vm.gameId).then(function (res) {
      vm.model = res.results
      if (!vm.model.itms) vm.model.itms = []
      if (vm.model['ts-p']) {
        const a = vm.model['ts-p'] / 1000
        const b = new Date(parseInt(a))
        vm.model['ts-p'] = angular.copy(b)
      }
      if (vm.model['ts-x']) {
        const a = vm.model['ts-x'] / 1000
        const b = new Date(parseInt(a))
        vm.model['ts-x'] = angular.copy(b)
      }
      if (vm.model.itms && vm.model.itms.length) {
        vm.model.itms.forEach((i) => {
          if (i['ts-unlock']) {
            const ts = i['ts-unlock'] / 1000
            i['ts-unlock'] = new Date(parseInt(ts))
          }
        })
      }
    })
  } else {
    vm.model['st'] = 0
    vm.model['ts-p'] = null
    vm.model['ts-x'] = null
  }

  GameService.getCollectibles(vm.channelId).then(function (res) {
    const cards = (res.results || []).filter((r) => r?.['k-prod'] == 2)

    vm.cards = cards.map((r) => ({ id: r?.id, name: r?.t || '-' }))
  })

  vm.openPostCalendar = function (post) {
    post.isOpen = true
  }

  vm.addPost = function () {
    vm.model.itms.push({
      url: '',
      'id-q': null,
      hint: '',
      pos: vm.model.itms.length + 1,
      isOpen: false,
      'ts-unlock': null,
    })
  }

  vm.removePost = function (index) {
    vm.model.itms.splice(index, 1)

  }

  vm.back = function () {
    $state.go('pub.games', { channelId: vm.channelId })
  }

  vm.save = function (isValid) {
    const localModal = angular.copy(vm.model)

    if (!localModal['t']) {
      toastr.warning('Title required fields')
      return
    }

    const itemLen = localModal['itms'].length

    if (itemLen == 0) {
      toastr.warning('At least one post is required')
      return
    }

    const itemFieldMissing =
      localModal['itms'].filter((item) => item['id-q'] && item['ts-unlock'] ).length !=
      itemLen

    if (itemFieldMissing) {
      toastr.warning('Please fill the required fields in social media posts sdfdf')
      return
    }

    if (!isValid) {
      toastr.warning('Please complete required fields')
      return
    }

    // Convert date fields
    if (localModal['ts-p']) localModal['ts-p'] = new Date(localModal['ts-p']).getTime() * 1000

    if (localModal['ts-x']) localModal['ts-x'] = new Date(localModal['ts-x']).getTime() * 1000

    localModal.itms.forEach((item) => {
      if (item['ts-unlock']) {
        item['ts-unlock'] = new Date(item['ts-unlock']).getTime() * 1000
      }
    })

    localModal['n-p'] = localModal.itms.length

    // Create
    if (!vm.isEdit) {
      GameService.create(vm.channelId, localModal).then(function (res) {
        toastr.success('Game created successfully')
        $state.go('pub.games.edit', {
          channelId: vm.channelId,
          gameId: res.results.id,
        })
      })
      return
    }

    delete localModal['ts-m']
    delete localModal['ts']

    // Update
    GameService.update(vm.channelId, vm.gameId, localModal).then(function () {
      toastr.success('Game updated successfully')
    })
  }

  // Upload Watchers
  $scope.$watch('vm.fileBanner', function (newVal, oldVal) {
    if (newVal === oldVal || !newVal) return
    vm.loadB = true
    UploadService.save('games', newVal, 'img-b', vm.model.id || vm.gameId).then(
      function (fileName) {
        vm.loadB = false
        vm.model['img-b'] = fileName
      },
    )
  })
  $scope.$watch('vm.fileBannerMob', function (newVal, oldVal) {
    if (newVal === oldVal || !newVal) return
    vm.loadBMob = true
    UploadService.save('games', newVal, 'img-mob', vm.model.id || vm.gameId).then(
      function (fileName) {
        vm.loadBMob = false
        vm.model['img-mob'] = fileName
      },
    )
  })

  $scope.$watch('vm.fileThumb', function (newVal, oldVal) {
    if (newVal === oldVal || !newVal) return
    vm.loadT = true
    UploadService.save('games', newVal, 'img-t', vm.model.id || vm.gameId).then(
      function (fileName) {
        vm.loadT = false
        vm.model['img-t'] = fileName
      },
    )
  })
  $scope.$watch('vm.filePrizeBanner', function (newVal, oldVal) {
    if (newVal === oldVal || !newVal) return
    vm.loadPB = true
    UploadService.save('games_prizes', newVal, 'img-pb', vm.model.id || vm.gameId).then(
      function (fileName) {
        vm.loadPB = false
        vm.model['img-pb'] = fileName
      },
    )
  })
  $scope.$watch('vm.filePrizeBannerMob', function (newVal, oldVal) {
    if (newVal === oldVal || !newVal) return
    vm.loadPBMob = true
    UploadService.save('games_prizes', newVal, 'img-pb-mob', vm.model.id || vm.gameId).then(
      function (fileName) {
        vm.loadPBMob = false
        vm.model['img-pb-mob'] = fileName
      },
    )
  })

  vm.deleteImage = function (key) {
    switch (key) {
      case 'img-b':
        vm.model['img-b'] = ''
        vm.loadB = false
        break
      case 'img-mob':
        vm.model['img-mob'] = ''
        vm.loadBMob = false
        break
      case 'img-t':
        vm.model['img-t'] = ''
        vm.loadT = false
        break
      case 'img-pb':
        vm.model['img-pb'] = ''
        vm.loadPB = false
        break
      case 'img-pb-mob':
        vm.model['img-pb-mob'] = ''
        vm.loadPBMob = false
        break
    }
    vm.model[key] = ''
  }

  var watch1 = $scope.$watch("vm.model['ts-p']", function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal) {
      vm.timezoneDate1NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate1LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    }
  })

  var watch2 = $scope.$watch("vm.model['ts-x']", function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal) {
      vm.timezoneDate2NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate2LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    }
  })

  $scope.$on('$destroy', function () {
    watch1()
    watch2()
  })

  // ---------- PRIZES SECTION (TABS) ----------

  vm.prizes = {
    published: [],
    unpublished: [],
    expired: [],
  }

  vm.activeTab = 'published' // default

  vm.changePrizeTab = function (tab) {
    vm.activeTab = tab
    vm.loadPrizes(tab)
  }

  // load prizes based on tab
  vm.loadPrizes = function (tab) {
    tab = tab || vm.activeTab
    if (!vm.gameId) return

    let serviceCall

    switch (tab) {
      case 'unpublished':
        serviceCall = GameService.listUnpublishedPrizes(vm.gameId)
        break
      case 'expired':
        serviceCall = GameService.listExpiredPrizes(vm.gameId)
        break
      default:
        serviceCall = GameService.listPublishedPrizes(vm.gameId)
    }

    serviceCall.then(function (res) {
      if (!res.results) {
        vm.prizes[tab] = []
        return
      }

      vm.prizes[tab] = res.results
        .sort(function (a, b) {
          return a.n - b.n
        })
        .map(function (item) {
          const createdAt = item['ts'] ? item['ts'] / 1000 : null
          const updateddAt = item['ts-m'] ? item['ts-m'] / 1000 : null

          return {
            ...item,
            ['ts']: createdAt,
            ['ts-m']: updateddAt,
          }
        })
    })
  }

  // open modal (create or edit)
  vm.openPrizeModal = function (item) {
    if (item) {
      vm.isEditPrize = true

      vm.prizeModel = angular.copy(item)
      if (vm.prizeModel['ts-start']) {
        const a = vm.prizeModel['ts-start'] / 1000
        const b = new Date(parseInt(a))
        vm.prizeModel['ts-start'] = angular.copy(b)
      }

      if (vm.prizeModel['ts-end']) {
        const a = vm.prizeModel['ts-end'] / 1000
        const b = new Date(parseInt(a))
        vm.prizeModel['ts-end'] = angular.copy(b)
      }
    } else {
      vm.isEditPrize = false
      vm.prizeModel = {
        id: 0,
        img: '',
        t: '',
        url: '',
        n: 0,
        'id-g': Number(vm.gameId),
        'ts-end': null,
        'ts-start': null,
      }
    }
    $('#modalPrize').modal('show')
  }

  // save (create or update)
  vm.savePrize = function (isValid) {
    const localPrizeModal = { ...vm.prizeModel }

    if (!localPrizeModal['t']) {
      toastr.warning('Prize title required fields')
      return
    }
    if (!localPrizeModal['url']) {
      toastr.warning('Prize URL required fields')
      return
    }

    // Convert date fields
    if (localPrizeModal['ts-start'])
      localPrizeModal['ts-start'] = new Date(localPrizeModal['ts-start']).getTime() * 1000
    if (localPrizeModal['ts-end'])
      localPrizeModal['ts-end'] = new Date(localPrizeModal['ts-end']).getTime() * 1000

    if (vm.isEditPrize) {
      delete localPrizeModal['ts']
      delete localPrizeModal['ts-m']
    }

    const saveCall = vm.isEditPrize
      ? GameService.updateGamePrize(localPrizeModal.id, localPrizeModal)
      : GameService.createGamePrize(localPrizeModal)

    saveCall.then(
      function () {
        toastr.success(vm.isEditPrize ? 'Prize updated' : 'Prize created')
        vm.loadPrizes(vm.activeTab)
        $('#modalPrize').modal('hide')
      },
      function (err) {
        toastr.error('Failed to save prize')
        console.error(err)
      },
    )
  }

  $scope.$watch('vm.prizeThumb', function (newVal, oldVal) {
    if (newVal === oldVal || !newVal) return
    vm.loadPrizeThumb = true
    UploadService.save('games_prizes', newVal, 'img', vm.prizeModel.id || vm.gameId).then(
      function (fileName) {
        vm.loadPrizeThumb = false
        vm.prizeModel['img'] = fileName
      },
    )
  })

  // delete prize
  vm.deletePrize = function (prize) {
    swal(
      {
        title: 'Delete Prize?',
        text: 'Are you sure you want to delete this prize?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        closeOnConfirm: true,
      },
      function (isConfirm) {
        if (!isConfirm) return
        GameService.deleteGamePrize(prize.id).then(
          function () {
            toastr.success('Prize deleted')
            vm.loadPrizes(vm.activeTab)
          },
          function (err) {
            toastr.error('Error deleting prize')
          },
        )
      },
    )
  }

  vm.deletePrizeImage = function (key) {
    switch (key) {
      case 'img':
        vm.prizeModel['img-b'] = ''
        vm.loadPrizeThumb = false
        break
    }
    vm.prizeModel[key] = ''
  }

  var watch3 = $scope.$watch("vm.prizeModel['ts-start']", function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal) {
      vm.timezoneDate3NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate3LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    }
  })

  var watch4 = $scope.$watch("vm.prizeModel['ts-end']", function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal) {
      vm.timezoneDate4NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate4LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    }
  })

  $scope.$on('$destroy', function () {
    watch3()
    watch4()
  })
  // initial load
  vm.loadPrizes('published')
}
